import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-sm-12 mb-3" }
const _hoisted_3 = { class: "row g-2 align-items-start" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative mb-0" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  colspan: "2",
  class: "text-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.modalTitle,
    "dialog-class": "modal-lg",
    modelValue: _ctx.merchant !== null,
    "body-class": "pt-0",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = (open) => !open && _ctx.hide())
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ConfirmModal, { ref: "confirmDelete" }, null, 512),
      _createVNode(_component_LoaderWrapper, { ref: "loader" }, {
        default: _withCtx(() => [
          (_ctx.merchant)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors('ip')
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newIp) = $event)),
                            type: "text",
                            class: _normalizeClass(["form-control form-control-sm", parentProps.class]),
                            placeholder: _ctx.helper.trans('labels.merchant_ip_whitelist_placeholder'),
                            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addIp && _ctx.addIp(...args)), ["prevent"]), ["enter"]))
                          }, null, 42, _hoisted_5), [
                            [_vModelText, _ctx.newIp]
                          ])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-primary text-capitalize-first",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addIp && _ctx.addIp(...args)))
                      }, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.ip_address')), 1),
                        _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (row) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: row.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(row.ip), 1),
                          _createElementVNode("td", _hoisted_10, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-danger text-nowrap",
                              onClick: ($event: any) => (_ctx.remove(row))
                            }, _cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                            ]), 8, _hoisted_11)
                          ])
                        ]))
                      }), 128)),
                      (_ctx.entries.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                            _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.helper.trans('labels.merchant_ip_whitelist_empty')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-secondary btn-sm text-capitalize-first",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}